import { EntryProvider } from '../../context';
import { CodeView } from '../code-view';
import { useParams } from 'react-router';

export const CodeEditor = () => {
  const { entryId } = useParams();
  if (!entryId) throw new Error('No active entry');

  return (
    <EntryProvider id={entryId}>
      <CodeView />
    </EntryProvider>
  );
};
